export default __webpack_public_path__ + "static/media/icon-moon.cce754ce.svg";